package com.bikompanion.data.gbfs

import kotlinx.serialization.Serializable

@Serializable
internal data class GbfsVehicleTypesResponse(
    val data: GbfsVehicleTypesData,
)
